import { ISignUpResponseModel } from "@models/dto/Rocketta/LicenseServer/Models/Auth/ISignUpResponseModel";
import LicenseServerBaseApi from "./baseApi";
import { ISignUpFederatedRequestModel } from "@models/dto/Rocketta/LicenseServer/Models/Auth/ISignUpFederatedRequestModel";
import { ISignInFederatedRequestModel } from "@models/dto/Rocketta/LicenseServer/Models/Auth/ISignInFederatedRequestModel";
import { ISignInResponseModel } from "@models/dto/Rocketta/LicenseServer/Models/Auth/ISignInResponseModel";
import { IResponseModel } from "@models/dto/Rocketta/LicenseServer/Models/IResponseModel";
import { AxiosResponse } from "axios";
import { IUserModel } from "@models/dto/Rocketta/LicenseServer/Models/Auth/IUserModel";

export class AuthApi {
  static signUpFederated(
    data: ISignUpFederatedRequestModel
  ): Promise<AxiosResponse<IResponseModel<ISignUpResponseModel>>> {
    return LicenseServerBaseApi.postWrapped<ISignUpResponseModel>("/Auth/SignUpFederated", data);
  }

  static signInFederated(
    data: ISignInFederatedRequestModel
  ): Promise<AxiosResponse<IResponseModel<ISignInResponseModel>>> {
    return LicenseServerBaseApi.postWrapped<ISignInResponseModel>("/Auth/SignInFederated", data);
  }

  static getCurrentUser(): Promise<AxiosResponse<IResponseModel<IUserModel>>> {
    return LicenseServerBaseApi.get<IUserModel>("/Auth/CurrentUser");
  }
}
